import { List } from 'immutable';
import { EDIT_IN_UI, RESET_UI } from './reducer';

const emptyDialogs = List([]);

export const editUi = (path, value) => ({
    path,
    type: EDIT_IN_UI,
    value,
});

export const editInUi = (path) => (value) => {
    return editUi(path, value);
};

export const addDialog = (dialog) => (dispatch, getState) => {
    const { ui } = getState();

    dispatch(
        editUi(
            ['dialogs'],
            ui.get('dialogs', emptyDialogs).push(dialog)
        )
    );
};

export const removeDialog = (id) => (dispatch, getState) => {
    const { ui } = getState();
    const dialogs = ui.get('dialogs', emptyDialogs);
    const newDialogs = dialogs.filter((d) => d.id !== id);

    dispatch(
        editUi(['dialogs'], newDialogs)
    );
};

export const resetUi = (keys) => ({
    keys,
    type: RESET_UI,
});



// WEBPACK FOOTER //
// ./src/redux/ui/actions.js